import * as React from 'react';

export default class InfoView extends React.Component<any, any> {
  render() {
    var { children } = this.props;
    const infoBox = 'infoViewBox';
    return <div className={infoBox}>{children}</div>;
  }
}
